const Reducer = (state, action) => {
    switch (action.type) {
        case 'SET_JOBNEWSLETTER_FORM_SENT':
            return {
                ...state,
                payload: action.payload
            };
        case 'SET_JOBNEWSLETTER_ERROR':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};

export default Reducer;
